import React, { useState, useEffect } from "react";
import { Container, Badge } from "react-bootstrap";
import "./Document.css";
import DownloadButton from "../../Buttons/DownloadButton";
import AddToCartButton from "../../Buttons/AddToCartButton";
import { removeItem } from "../../../Reducers/cartReducer";
import { useDispatch, useSelector } from "react-redux";
import GalleryModal from "../../Gallery/GalleryModal/GalleryModal";
import { useTranslation } from "react-i18next";

const Article = ({ documentContent }) => {
  const [showRemove, setShowRemove] = useState(false);
  const [showModal, setShowModal] = useState(false);

  const cartItems = useSelector((state) => state.cart.items);

  const dispatch = useDispatch();

  const { t } = useTranslation();

  useEffect(() => {
    const existingItem = cartItems.find(
      (el) => el.globalAssetId === documentContent.globalAssetId
    );

    if (existingItem) {
      setShowRemove(true);
    }
  }, []);

  useEffect(() => {
    const existingItem = cartItems.find(
      (el) => el.globalAssetId === documentContent.globalAssetId
    );

    if (!existingItem) {
      setShowRemove(false);
    } else {
      setShowRemove(true);
    }
  }, [cartItems]);

  const handleClose = () => setShowModal(false);
  const handleShow = () => setShowModal(true);

  const removeFromCart = (e) => {
    e.stopPropagation();
    dispatch(removeItem(documentContent.globalAssetId));
    setShowRemove(false);
  };

  return (
    <>
      {documentContent && (
        <GalleryModal
          show={showModal}
          handleClose={handleClose}
          item={documentContent}
          isDocument={true}
        />
      )}
      <Container fluid className="document">
        <div className="pull-left document-img" onClick={handleShow}>
          <img src={documentContent.coverUrl} alt={documentContent.title} />
        </div>
        <div className="document-info d-flex flex-column justify-content-between">
          <div>
            <h4 className="media-heading">{documentContent.title}</h4>
          </div>
          <small>
            <span>
              {documentContent.publishingDate.slice(0, 10)}{" "}
              {documentContent.publishingDate.slice(11, 19)}
            </span>
            <br />
            <span>{documentContent.downloads} Downloads</span>
          </small>
          <span className="pull-right">
            {!showRemove ? (
              <>
                <AddToCartButton
                  item={documentContent}
                  setShow={setShowRemove}
                />
                <DownloadButton item={documentContent} />
              </>
            ) : (
              <Badge
                bg="danger"
                className="custom-button position-static pull-right"
                role="button"
                onClick={(e) => removeFromCart(e)}
              >
                {t("remove")}
              </Badge>
            )}
          </span>
        </div>
      </Container>
    </>
  );
};

export default Article;
